// TOPのみ　アンカーリンク対応
function setupOwnPageAnchorClick() {
    const allNavAnchors = document.querySelectorAll(".menu-drawer__menu-item");
    allNavAnchors.forEach((el) => {
        const href = el.getAttribute("href");
        if (href.charAt(1) == "#") {
            el.addEventListener("click", function(e) {
                e.preventDefault();
                document.body.classList.remove("overflow-hidden-tablet");
                const target = this.getAttribute("href").substring(1);
                const targetEl = document.querySelector(target);
                if (targetEl) {
                    targetEl.scrollIntoView({
                        behavior: "auto",
                        block: "start",
                    });
                }
                
                history.pushState(null, "", target);
                
                const drawerEl = document.getElementById("Details-menu-drawer-container");
                drawerEl.classList.remove("draw-opening");
                drawerEl.removeAttribute("open");
                
            })
        }
    })
}
document.addEventListener("DOMContentLoaded", () => {
  if (location.href === location.origin || location.pathname === "/") {
    setupOwnPageAnchorClick();
  }
})